import { render, staticRenderFns } from "./BaseRoundList.vue?vue&type=template&id=54b837f3&"
import script from "./BaseRoundList.vue?vue&type=script&lang=js&"
export * from "./BaseRoundList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports